import { lazy } from "react";

const ContentBlock = lazy(() => import("../../components/ContentBlock"));
const Container = lazy(() => import("../../common/Container"));
const ScrollToTop = lazy(() => import("../../common/ScrollToTop"));

const ComingSoon = () => {
  return (
    <Container>
      <ScrollToTop />
      <ContentBlock
        direction="left"
        japaneseText="こんにちは,"
        title={"Coming soon title"}
        subTitle={"Coming soon subtitle"}
        content={`Coming soon message`}
        icon="kosu_jumping.png"
        iconMobile="kosu_jumping_medium.png"
        id="intro"
      />
    </Container>
  );
};

export default ComingSoon;
